// @ts-strict-ignore
import type { ReactNode } from "react";
import { createContext } from "react";

interface BannersData {
  banners: any[];
  bannersHeight: number;
  setBannersHeight: (height: number) => void;
  createBanner: (bannerId: string, banner: ReactNode) => void;
  removeBanner?: (bannerId: string) => void;
}

const BannersContext = createContext<BannersData>(null);

export type { BannersData };
export { BannersContext };
